import { NodeModel } from "storm-react-diagrams";

export default class LabelNodeModel extends NodeModel {
    constructor() {
        super("label");
    }
}
